export default function featuredEventSlider() {
  const featuredSlider = $('.featuredEvent__slider');

  if (featuredSlider.length > 0) {
    featuredSlider.each(function (num, elem) {
      elem = $(elem);
      elem.slick({
        mobileFirst: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 500,
        cssEase: 'ease',
        easing: 'linear',
        touchMove: true,
        accessibility: true,
        autoplay: false,
        draggable: true,
        swipe: true,
        arrows: true,
        edgeFriction: 0.0005,
        touchThreshold: 20,
        prevArrow: $('.slider-prev-arrow')[num],
        nextArrow: $('.slider-next-arrow')[num],
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });
  }
}
